import axios from 'axios';
import Environment from "../utils/Environment";
import { parseErrorMessages } from "../utils/ErrorUtils";

const handleValidation = async (
  selectedDC: string,
  tabType: string,
  setIsFileValidated: (value: boolean) => void,
  files: File[],
  setIsLoading: (value: boolean) => void,
  setAlertMessage: (message: string | null) => void,
  setAlertSeverity: (severity: 'success' | 'error' | 'info' | 'warning') => void,
  showSuccess: (msg?: string) => void,
  showError: (msg?: string, fullErrors?: string[]) => void,
  waveStatusCallback?: (data: any) => void
) => {
  const data = new FormData();
  files.forEach(file => {
    data.append('files', file);
  });
  data.append('dcName', selectedDC);
  let validationAPI: string | undefined;
  let fileTypeLabel: string;
  
  switch (tabType) {
    case 'IN02':
      // Check combined IN02 DC first (e.g. WAUB)
      const combinedIN02DCs = Environment.getCombinedIN02DCList();
      const isCombinedIN02DC = selectedDC && combinedIN02DCs.includes(selectedDC);

      // Check if the selected DC is in the custom IN02 DC list
      const customIN02DCs = Environment.getCustomIN02DCList();
      const isCustomIN02DC = selectedDC && customIN02DCs.includes(selectedDC);

      if (isCombinedIN02DC) {
        validationAPI = Environment.getValidationIN02CombinedAPI();
        fileTypeLabel = 'IN02';
      } else if (isCustomIN02DC) {
        validationAPI = Environment.getValidationCustomIN02API();
        fileTypeLabel = 'Custom IN02';
      } else {
        validationAPI = Environment.getValidationIN02API();
        fileTypeLabel = 'IN02';
      }
      break;
    case 'XDOCK':
    default:
      validationAPI = Environment.getValidationAPI();
      fileTypeLabel = 'XDOCK';
      break;
  }
  
  setIsLoading(true);
  try {
    const response = await axios.post(validationAPI || '', data);
    if (response.status === 200) {
      setIsFileValidated(true);
      // Check if response has wave status
      if (response.data && response.data.waveStatusApiResponseList && response.data.waveStatusApiResponseList.length > 0) {
        if (waveStatusCallback) {
          waveStatusCallback(response.data);
        }
      } else {
        showSuccess(`${fileTypeLabel} File Validated successfully - No Errors found`);
      }
    } else {
      setIsFileValidated(false);
      const errorMessage = `${fileTypeLabel} File Validation failed: ` + (response.data.message || response.data);
      const parsedErrors = parseErrorMessages(response.data.message || response.data);
      // Pass parsed errors if there are multiple error lines or if parsing found multiple errors
      const shouldShowFullErrors = parsedErrors.length > 1 || parsedErrors.some(e => 
        /^Error.*line/i.test(e) || 
        /error.*line/i.test(e) || 
        /^.*\.(csv|txt):/i.test(e)
      );
      if (shouldShowFullErrors) {
        showError(errorMessage, parsedErrors);
      } else {
        showError(errorMessage);
      }
    }
  } catch (err: any) {
    console.log('Error:', err);
    setIsFileValidated(false);
    if (err.response) {
      const errorMessage = `${fileTypeLabel} Validation failed: ` + (err.response.data.message || err.response.data);
      const parsedErrors = parseErrorMessages(err.response.data.message || err.response.data);
      // Pass parsed errors if there are multiple error lines or if parsing found multiple errors
      const shouldShowFullErrors = parsedErrors.length > 1 || parsedErrors.some(e => 
        /^Error.*line/i.test(e) || 
        /error.*line/i.test(e) || 
        /^.*\.(csv|txt):/i.test(e)
      );
      if (shouldShowFullErrors) {
        showError(errorMessage, parsedErrors);
      } else {
        showError(errorMessage);
      }
    } else if (err.request) {
      showError(`${fileTypeLabel} Validation failed: No response received`);
    } else {
      showError(`${fileTypeLabel} Validation failed: ` + err.message);
    }
  } finally {
    setIsLoading(false);
  }
};

export default handleValidation;
